/**
 * Returns name acronym - get first letter from every word in string and make it uppercase
 *
 * @param name
 * @returns {string}
 */
export const nameAcronym = name => name
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .replace(/[-_:/]/g, '')
    .substr(0, 3)
    .toUpperCase()
